import { useForm, usePage, Link } from "@inertiajs/react";
import AuthLayout from "@/layout/AuthLayout";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import GoogleSignInButton from "@/components/app/GoogleSignInButton";
import OrDivider from "@/components/app/OrDivider";

export default function SignUp() {
  const { routes } = usePage().props;
  const form = useForm({
    first_name: "",
    last_name: "",
    email_address: "",
    password: "",
    password_confirmation: "",
  });

  function submit(e) {
    e.preventDefault();
    form.post(routes.signup);
  }

  return (
    <AuthLayout>
      <Card>
        <CardHeader>
          <CardTitle>Create an account</CardTitle>
          <CardDescription>Join GameKnight and find your next game night</CardDescription>
        </CardHeader>

        <CardContent className="space-y-4">
          <GoogleSignInButton action={routes.google_auth} />
          <OrDivider />

          <form onSubmit={submit} className="space-y-4">
            <div className="grid grid-cols-2 gap-3">
              <div className="space-y-1.5">
                <Label htmlFor="first_name">First name</Label>
                <Input
                  id="first_name"
                  autoFocus
                  placeholder="Ada"
                  value={form.data.first_name}
                  onChange={(e) => form.setData("first_name", e.target.value)}
                />
                {form.errors.first_name && (
                  <p className="text-xs text-destructive">{form.errors.first_name}</p>
                )}
              </div>
              <div className="space-y-1.5">
                <Label htmlFor="last_name">Last name</Label>
                <Input
                  id="last_name"
                  placeholder="Lovelace"
                  value={form.data.last_name}
                  onChange={(e) => form.setData("last_name", e.target.value)}
                />
                {form.errors.last_name && (
                  <p className="text-xs text-destructive">{form.errors.last_name}</p>
                )}
              </div>
            </div>

            <div className="space-y-1.5">
              <Label htmlFor="email_address">Email</Label>
              <Input
                id="email_address"
                type="email"
                autoComplete="username"
                placeholder="you@example.com"
                value={form.data.email_address}
                onChange={(e) => form.setData("email_address", e.target.value)}
              />
              {form.errors.email_address && (
                <p className="text-xs text-destructive">{form.errors.email_address}</p>
              )}
            </div>

            <div className="space-y-1.5">
              <Label htmlFor="password">Password</Label>
              <Input
                id="password"
                type="password"
                autoComplete="new-password"
                placeholder="At least 8 characters"
                value={form.data.password}
                onChange={(e) => form.setData("password", e.target.value)}
              />
              {form.errors.password && (
                <p className="text-xs text-destructive">{form.errors.password}</p>
              )}
            </div>

            <div className="space-y-1.5">
              <Label htmlFor="password_confirmation">Confirm password</Label>
              <Input
                id="password_confirmation"
                type="password"
                autoComplete="new-password"
                placeholder="••••••••"
                value={form.data.password_confirmation}
                onChange={(e) => form.setData("password_confirmation", e.target.value)}
              />
              {form.errors.password_confirmation && (
                <p className="text-xs text-destructive">{form.errors.password_confirmation}</p>
              )}
            </div>

            <Button type="submit" className="w-full" disabled={form.processing}>
              {form.processing ? "Creating account…" : "Create account"}
            </Button>
          </form>
        </CardContent>

        <CardFooter className="justify-center text-sm text-muted-foreground">
          Already have an account?&nbsp;
          <Link href={routes.login} className="text-primary hover:underline font-medium">
            Sign in
          </Link>
        </CardFooter>
      </Card>
    </AuthLayout>
  );
}

